import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const MarketInsights = lazy(() => import("./listingPage/index.jsx"));
const MarketInsightsDetails = lazy(() => import("./detailPage/index.jsx"));

export const marketInsightsRoutes = {
  children: [
    {
      path: "/market-insights",
      element: <MarketInsights />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/market-insights/:marketInsightId",
      element: <MarketInsightsDetails />,
      errorElement: <ErrorBoundary />
    }
  ]
};
